import React from "react"
import { useTranslation } from "react-i18next"

import { MAX_LENGTH_FEEDBACK_TEXT } from "shared/constants/app-constants"
import { Textarea } from "shared/ui/input/text/Textarea"

export const FeedbackMessageInput = React.memo(() => {
  const { t } = useTranslation()

  return (
    <Textarea.Root
      inputID="feedback-message"
      name="message"
      label={t("Feedback.AdditionalNotes")}
      maxLength={MAX_LENGTH_FEEDBACK_TEXT}
      autoFocus
      required
    >
      <Textarea.Label />
      <Textarea.Focus>
        <Textarea.Input
          className="feedback-overlay__message-textarea"
          data-testid="feedback-message__input"
          rows={4}
          placeholder={t("Feedback.MessageInputPlaceholder")}
        />
        <Textarea.Counter />
      </Textarea.Focus>
      <Textarea.ErrorMessage />
    </Textarea.Root>
  )
})
